import * as yup from 'yup';
import type { CalculateRes } from 'types/records';
import { VISIBILITY_STATE } from 'types/enums';

export const calculateResponseSchema = yup.object().shape({
  attributes: yup.array().of(
    yup.object().shape({
      sectionId: yup.string().required(),
      formItem: yup
        .object()
        .shape({
          id: yup.string().required(),
          name: yup.string().required(),
          title: yup.string(),
          definition: yup.object().required(),
        })
        .nullable(),
      state: yup.string().oneOf(Object.values(VISIBILITY_STATE)).nullable(),
      visibility: yup
        .object()
        .shape({
          visibilityState: yup.string().oneOf(Object.values(VISIBILITY_STATE)).required(),
          formItemUiDefinition: yup
            .object()
            .nullable()
            .shape({
              columnBorderColor: yup.string().nullable(),
              attributeColor: yup.string().nullable(),
              textStyle: yup.object().nullable().shape({
                bold: yup.boolean().nullable(),
                italic: yup.boolean().nullable(),
                underline: yup.boolean().nullable(),
                color: yup.string().nullable(),
              }),
              icon: yup.string().nullable(),
            })
            .nullable(),
          multipleUiDefinitions: yup.boolean().nullable(),
        })
        .nullable(),
      automaticSequenceAttribute: yup.object().nullable(),
      buttonAttribute: yup.object().nullable(),
      checkboxAttribute: yup.object().nullable(),
      commentAttribute: yup.object().nullable(),
      computedAttribute: yup.object().nullable(),
      dateAttribute: yup.object().nullable(),
      emailAttribute: yup.object().nullable(),
      fileUploadAttribute: yup.object().nullable(),
      numberAttribute: yup.object().nullable(),
      phoneNumberAttribute: yup.object().nullable(),
      radioButtonAttribute: yup.object().nullable(),
      recordsAttribute: yup.object().nullable(),
      recordsDisplayAttribute: yup.object().nullable(),
      richTextAttribute: yup.object().nullable(),
      tablesAttribute: yup.object().nullable(),
      textAttribute: yup.object().nullable(),
      usersAttribute: yup.object().nullable(),
    })
  ),
}) as yup.Schema<CalculateRes>;
